/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTaxReturn = /* GraphQL */ `
  subscription OnCreateTaxReturn($owner: String) {
    onCreateTaxReturn(owner: $owner) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateTaxReturn = /* GraphQL */ `
  subscription OnUpdateTaxReturn($owner: String) {
    onUpdateTaxReturn(owner: $owner) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteTaxReturn = /* GraphQL */ `
  subscription OnDeleteTaxReturn($owner: String) {
    onDeleteTaxReturn(owner: $owner) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateTaxDocument = /* GraphQL */ `
  subscription OnCreateTaxDocument($owner: String) {
    onCreateTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateTaxDocument = /* GraphQL */ `
  subscription OnUpdateTaxDocument($owner: String) {
    onUpdateTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteTaxDocument = /* GraphQL */ `
  subscription OnDeleteTaxDocument($owner: String) {
    onDeleteTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreatePreviousTaxDocument = /* GraphQL */ `
  subscription OnCreatePreviousTaxDocument($owner: String) {
    onCreatePreviousTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdatePreviousTaxDocument = /* GraphQL */ `
  subscription OnUpdatePreviousTaxDocument($owner: String) {
    onUpdatePreviousTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeletePreviousTaxDocument = /* GraphQL */ `
  subscription OnDeletePreviousTaxDocument($owner: String) {
    onDeletePreviousTaxDocument(owner: $owner) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
